<template>
  <component :is="cmpList[tmpType]" :comData="comData"></component>
</template>

<script>
import styleOne from './components/style-one'
import styleTwo from './components/style-two'
export default {
  components: [styleOne,styleTwo,styleTwo,styleTwo,styleTwo],
  props: {
		comData: {
			type: Array,
			default() {
				return []
			}
		},
    tmpType: {
      type: Number,
      default: 0
    }
	},
  data() {
    return {
      cmpList: [styleOne,styleTwo,styleTwo,styleTwo,styleTwo]
    }
  }
}
</script>

<style>

</style>